import script from "./TradeFlowData.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeFlowData.vue?vue&type=script&setup=true&lang=js"

import "./TradeFlowData.vue?vue&type=style&index=0&id=07cea45c&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07cea45c"]])

export default __exports__